/**
 * Lib module What you see is what you get (editors)
 * Current editor in use: Froala editor
 *
 */

Lib.Wysiwyg = (function() {

    var self = {};

    $(Lib).on('document.ready', function() {
        self.bindEditor($('[data-wysiwyg]'));
    });

    self.bindEditor = function(editors) {
        editors.each(function() {
            let domEl = $(this).get(0);
            self.editor(domEl, ($(this).data('wysiwyg') || {}));
        });
    };

    self.editor = function(textarea, options_) {

        let options = $.extend(true, {
            placeholder: {
                text: '',
                hideOnClick: true
            },
            toolbar: {
                buttons: ['bold', 'italic', 'underline', 'strikethrough']
            },
            paste: {
                forcePlainText: false,
                cleanPastedHTML: true
            }
        }, options_);

        return new MediumEditor(textarea, options);
    };

    return self;

}());
